import { serveAuxclickHardeningExperiment } from '../experiments';

/**
 * Returns true for middle-clicks (button === 1) only when the auxclick hardening
 * experiment is active.  Right-clicks are excluded to avoid double-counting with
 * onContextMenu.
 *
 * When the experiment is inactive (control cohort / gate off) falls back to accepting
 * every auxclick so existing behaviour is preserved.
 */
export const isAuxClick = (e: { button: number }): boolean => {
	if (serveAuxclickHardeningExperiment()) {
		return e.button === 1;
	}
	return true;
};
